export const getOrigin = () => {
    const global = globalThis as typeof globalThis & Window;
    if (global.__TWILIO_FLEX_SDK__?.appType === "flex-mobile") {
        if (global.Twilio?.Flex) {
            return "flexui";
        }
        return "mobile";
    }
    if (global.__TWILIO_FLEX_SDK__?.appType) {
        return global.__TWILIO_FLEX_SDK__.appType;
    }
    if (global.Twilio?.Flex) {
        return "flexui";
    }

    return "headless";
};
